import RootElement from "./src/RootPageLayouts/RootElement";
import "./src/styles/global.css";

export const wrapRootElement = ({ element }) => {
  return <RootElement>{element}</RootElement>;
};
